import { Application, Controller } from "@hotwired/stimulus";

class FormCheckboxController extends Controller {
  static targets = ['checkbox']

  selectAll() {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = true
    })
  }

  clearSelection() {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
    })
  }
}

// Registered in admin.js
export { FormCheckboxController };
